<style lang="stylus">
    .ExpandLibrary-container
        overflow auto
        padding 8px
        display flex
        flex-wrap wrap
        row-gap 8px
        column-gap 8px
        background-color var(--bg-color-tertiary)
        box-shadow $box-shadow
        border-radius 8px
        &.noborder
            box-shadow none
        .ExpandLibrary-imgbox
            width 40px
            height 40px
            border 1px solid transparent
            border-radius 6px
            &.active
                background var(--bg-color-float-fast-expand-library-active)
            img
                width 100%
                height 100%
</style>

<template>
    <div
        class="ExpandLibrary-container"
        :style="{ 'max-height': `${expandMaxHeight}px`, width: `${contentWidth}px` }"
        :class="{ noborder: noborder }"
    >
        <div
            class="ExpandLibrary-imgbox"
            v-for="(item, index) in expandData"
            :key="index"
            :class="{ active: choiceIndex === index }"
            @click="replaceSymbol(index)"
            @mouseenter="hoverSymbol(index)"
            @mouseleave="hoverSymbol(-1)"
        >
            <img :src="imgList[index]" alt="" />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Watch, Vue, Inject, Prop } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class ExpandLibrary extends Vue {
        @Inject()
        ["showMessage"];
        @Prop({
            default: false,
        })
        noborder;

        data: Array<object> = [];
        overflowType: string = "unset";
        imgList: Array<string> = [];

        @Watch("expandData", { immediate: true })
        createImgList(nv, ov) {
            if (nv) {
                if (this.imgList.length > 0) {
                    for (let i = 0; i < this.imgList.length; i++) {
                        URL.revokeObjectURL(this.imgList[i]);
                    }
                }
                this.imgList = [];
                for (let i = 0; i < this.expandData.length; i++) {
                    this.imgList.push(this.itemIcon(this.expandData[i]["blob"]));
                }
            }
        }
        itemIcon(blob) {
            return !blob ? "" : URL.createObjectURL(blob);
        }
        replaceSymbol(index) {
            window["_view"].clickLibMenu(
                this.expandData[index]["data"],
                this.expandData[index]["name"],
                this.expandData[index][this.lang + "_name"],
                this.expandData[index]["tableID"]
            );
            this.$store.commit("closeContext"); //选中后关闭右键弹窗
        }
        hoverSymbol(index) {
            this.choiceIndex = index;
        }
        get contentWidth() {
            let width = 200,
                count = 0;
            if (this.expandMaxHeight == 320) {
                count = 24;
            } else {
                count = 16;
            }
            return this.expandData.length > count ? width + 10 : width;
        }
        get expandData() {
            if (this.expandMaxHeight == 200) return this.$store.state.dialog.expandLibraryData.filter((v, k) => k < 16);
            else return this.$store.state.dialog.expandLibraryData;
        }
        get expandMaxHeight() {
            return this.$store.state.dialog.expandMaxHeight;
        }

        get choiceIndex() {
            return this.$store.state.dialog.expandChoiceIndex;
        }

        set choiceIndex(index) {
            this.$store.state.dialog.expandChoiceIndex = index;
        }

        mounted() {
            this.choiceIndex = -1;
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "noReplace": "不能修改连接线，组合形状或其他特殊形状"
  },
  "en": {
    "noReplace": "Could not change connectors, grouped shapes or other special shapes."
  },
  "fr": {
    "noReplace": "Impossible de modifier les lignes de connexion, les formes combinées ou d'autres formes spéciales"
  },
  "de": {
    "noReplace": "Verbindungslinien, kombinierte Formen oder andere spezielle Formen können nicht geändert werden"
  },
  "jp": {
    "noReplace": "接続線、結合形状、またはその他の特殊な形状は変更できません"
  },
  "es": {
    "noReplace": "No se pueden modificar líneas de conexión, formas combinadas u otras formas especiales"
  },
  "pt": {
    "noReplace": "Não é possível modificar linhas de conexão, formas combinadas ou outras formas especiais"
  },
  "it": {
    "noReplace": "Non è possibile modificare linee di collegamento, forme combinate o altre forme speciali"
  },
  "tw": {
    "noReplace": "不能修改連接線，組合形狀或其他特殊形狀"
  },
  "kr": {
    "noReplace": "커넥터, 그룹화된 모양 또는 기타 특수 모양을 변경할 수 없습니다."
  }
}
</i18n>
